import { render, staticRenderFns } from "./PortsView.vue?vue&type=template&id=84c5d662&"
import script from "./PortsView.vue?vue&type=script&lang=js&"
export * from "./PortsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports